import { actionTypes } from './actions';
import initialState from './initialState';
import { createReducer } from 'utils/redux';
import { fromJS } from 'immutable';

const getNotificationsSettings = (state) => state.set('loading', true).set('error', null);
const getNotificationsSettingsSuccess = (state, { payload }) =>
  state.set('data', fromJS(payload)).set('loading', false);
const getNotificationsSettingsError = (state, { payload }) =>
  state.set('loading', false).set('error', fromJS(payload));
const saveNotificationsSettings = (state) => state.set('updating', true).set('error', null);
const saveNotificationsSettingsSuccess = (state, { payload }) =>
  state.set('data', fromJS(payload)).set('updating', false);

export default createReducer(initialState, {
  [actionTypes.GET_NOTIFICATIONS_SETTINGS]: getNotificationsSettings,
  [actionTypes.GET_NOTIFICATIONS_SETTINGS_SUCCESS]: getNotificationsSettingsSuccess,
  [actionTypes.GET_NOTIFICATIONS_SETTINGS_FAILURE]: getNotificationsSettingsError,
  [actionTypes.SAVE_NOTIFICATIONS_SETTINGS]: saveNotificationsSettings,
  [actionTypes.SAVE_NOTIFICATIONS_SETTINGS_SUCCESS]: saveNotificationsSettingsSuccess,
});
